import { auth } from "../firebase";

import {
    saveProgress,
    loadAllProgress,
} from "../services/progress";

const STORAGE_KEY = "completedActivities";

export function getCompletedActivities() {
    return JSON.parse(
        localStorage.getItem(STORAGE_KEY) || "[]"
    );
}

export async function markComplete(activityId) {

    if (!auth.currentUser) {
        return;
    }

    await saveProgress(activityId);

    window.dispatchEvent(
        new Event("progressUpdated")
    );
}

export function isComplete(activityId) {
    return getCompletedActivities().includes(activityId);
}
